export default {
  Bajram_Curri: "Bajram Curri",
  Bajze: "Bajzë",
  Ballsh: "Ballsh",
  Berat: "Berat",
  Bilisht: "Bilisht",
  Bulqize: "Bulqizë",
  Burrel: "Burrel",
  Cerrik: "Cërrik",
  Corovode: "Çorovodë",
  Delvine: "Delvinë",
  Divjake: "Divjakë",
  Durres: "Durrës",
  Elbasan: "Elbasan",
  Erseke: "Ersekë",
  Fier: "Fier",
  Fierze: "Fierzë",
  Finiq: "Finiq",
  Fushe_Arrez: "Fushë-Arrëz",
  Fushe_Kruje: "Fushë-Krujë",
  Gjirokaster: "Gjirokastër",
  Gramsh: "Gramsh",
  Himare: "Himarë",
  Kamez: "Kamëz",
  Kavaje: "Kavajë",
  Kelcyre: "Këlcyrë",
  Klos: "Klos",
  Konispol: "Konispol",
  Koplik: "Koplik",
  Korce: "Korçë",
  Kraste: "Krastë",
  Krrabe: "Krrabë",
  Kruje: "Krujë",
  Krume: "Krumë",
  Kucove: "Kuçovë",
  Kukes: "Kukës",
  Kurbnesh: "Kurbnesh",
  Lac: "Laç",
  Leskovik: "Leskovik",
  Lezhe: "Lezhë",
  Libohove: "Libohovë",
  Librazhd: "Librazhd",
  Lushnje: "Lushnjë",
  Maliq: "Maliq",
  Mamurras: "Mamurras",
  Manez: "Manëz",
  Memaliaj: "Memaliaj",
  Milot: "Milot",
  Orikum: "Orikum",
  Patos: "Patos",
  Peqin: "Peqin",
  Permet: "Përmet",
  Peshkopi: "Peshkopi",
  Pogradec: "Pogradec",
  Polican: "Poliçan",
  Prrenjas: "Prrenjas",
  Puke: "Pukë",
  Reps: "Reps",
  Roskovec: "Roskovec",
  Rreshen: "Rrëshen",
  Rrogozhine: "Rrogozhinë",
  Rubik: "Rubik",
  Sarande: "Sarandë",
  Selenice: "Selenicë",
  Shengjin: "Shëngjin",
  Shijak: "Shijak",
  Shkoder: "Shkodër",
  Sukth: "Sukth",
  Tepelene: "Tepelenë",
  Tirana: "Tirana",
  Ulez: "Ulëz",
  Ura_Vajgurore: "Ura Vajgurore",
  Vau_i_Dejes: "Vau i Dejës",
  Vlore: "Vlorë",
  Vore: "Vorë",
};
